import store from 'redux/redux'

const getDataFromRegions = regions => {
  return regions.items.map(region => ({
    id: region.id,
    name: region.name,
    code: region.code,
    country_id: region.country_id
  }))
}

const getDataFromCountries = countries => {
  return countries.items.map(country => ({
    id: country.id,
    name: country.name,
    code: country.code
  }))
}

const getRegionsDataByCountry = regionsData => {
  let regionsDataByCountry = {}
  regionsData.forEach((region, index, regionsData) => {
    let regionCode = getRegionCodeFromId({ regionsData, id: region.id });
    let countryCode = getCountryCodeFromRegionCode(regionCode);
    let countryMeta = countryCodeToMeta(countryCode);
    if (countryMeta != null) {
      if (!(countryCode in regionsDataByCountry)) {
        regionsDataByCountry[countryCode] = {
          countryFullName: countryMeta.name,
          countryId: countryMeta.id,
          regions: [region]
        }
      } else {
        regionsDataByCountry[countryCode].regions.push(region)
      }
    }
  })
  return regionsDataByCountry
}

const getDataFromReferenceRegions = ({ regions, regionsData, selectedRegionId }) => {
  let referenceRegionsData
  referenceRegionsData = regions.items.map(region => {
    let regionCode = region.dst_code
    let currentRegionData = regionsData.filter(regionData => (regionCode.toUpperCase() === regionData.code.toUpperCase() ? true : false))[0]
    return currentRegionData
  })
  let selectedRegionData = regionsData.filter(regionData => (Number(regionData.id) === selectedRegionId ? true : false))[0]
  referenceRegionsData.push(selectedRegionData)
  return referenceRegionsData
}

const getSameCountryRegionsData = (regions, selectedRegionId) => {
  let regionsData = getDataFromRegions(regions)
  let selectedRegionCode = getRegionCodeFromId({ regionsData, id: selectedRegionId })
  let selectedCountryCode = getCountryCodeFromRegionCode(selectedRegionCode)
  let sameCountryRegionsData = regionsData.filter(region => getCountryCodeFromRegionCode(region.code) === selectedCountryCode)
  return sameCountryRegionsData
}

const getRegionIds = regions => {
  let regionsData = getDataFromRegions(regions)
  return regionsData.map(region => region.id)
}

const getSameCountryRegionIds = (regions, selectedRegionId) => {
  let sameCountryRegionsData = getSameCountryRegionsData(regions, selectedRegionId)
  let sameCountryRegionIds = sameCountryRegionsData.map(region => region.id)
  return sameCountryRegionIds
}

const getRegionNameFromId = ({ regionsData, id }) => {
  let name
  for (let i = 0; i < regionsData.length; i++) {
    if (Number(regionsData[i].id) === Number(id)) {
      name = regionsData[i].name
      break
    }
  }

  return name
}

const getRegionCodeFromId = ({ regionsData, id }) => {
  let selectedRegionData = regionsData.filter(region => Number(region.id) === Number(id))
  let selectedRegionCode = selectedRegionData[0].code
  return selectedRegionCode
}

const getRegionIdFromCode = ({ regionsData, code }) => {
  let selectedRegionData = regionsData.filter(region => region.code === code)
  let selectedRegionId = selectedRegionData[0].id
  return selectedRegionId
}

const getCountryCodeFromRegionCode = regionCode => regionCode.substring(0, 2)

const countryCodeToMeta = code => {
  const countriesData = store.getState().REGIONS.countriesData
  code = code.toUpperCase()
  const countryData = countriesData.filter(item => item.code === code)[0]
  return countryData;
}

const countryCodeToFullName = code => {
  const meta = countryCodeToMeta( code );
  return meta.name;
}

const getSortedCountryCodesByCountryName = ({ regionsDataByCountry }) => {
  return Object.keys(regionsDataByCountry).sort(
    (countryCodeA, countryCodeB) => (regionsDataByCountry[countryCodeA].countryFullName > regionsDataByCountry[countryCodeB].countryFullName ? 1 : -1)
  )
}

const getSortedRegionsByRegionName = ({ regionsData }) => {
  return regionsData.sort((regionA, regionB) => (regionA.name > regionB.name ? 1 : -1))
}

const regionTools = {
  getDataFromRegions,
  getDataFromCountries,
  getRegionsDataByCountry,
  getDataFromReferenceRegions,
  getSameCountryRegionsData,
  getRegionIds,
  getSameCountryRegionIds,
  getRegionNameFromId,
  getRegionCodeFromId,
  getRegionIdFromCode,
  getCountryCodeFromRegionCode,
  countryCodeToFullName,
  countryCodeToMeta,
  getSortedCountryCodesByCountryName,
  getSortedRegionsByRegionName
}
export default regionTools



// WEBPACK FOOTER //
// ./src/utils/regions/regionTools.js